@if (asset()) {
  <div class="dialog" [style.height.px]="height()">
    <div class="dialog-inner" appSmoothAutoHeight (height)="height.set($event)">
      <img [src]="asset() | assetUrl: asset().version_data.watermark_uuid : 600" alt="" class="gallery-image" />
      <h1>Share Asset</h1>
    </div>
  </div>

  <ng-template #footerContent>
    <div class="dialog-bottom-inner">
      @if (gallery()) {
        <app-share-dialog-social-footer [gallery]="gallery()" [asset]="asset()"> </app-share-dialog-social-footer>
      }
    </div>
  </ng-template>

  @if (publicAccessLevel() !== 'no_access') {
    @if (isMobile) {
      <div class="dialog-bottom-container">
        <div class="dialog-bottom">
          <ng-container *ngTemplateOutlet="footerContent"></ng-container>
        </div>
      </div>
    } @else {
      <div class="dialog-bottom-container" [@dialogBottomOuter]>
        <div class="dialog-bottom-padding"></div>
        <div class="dialog-bottom" [@dialogBottomInner]>
          <ng-container *ngTemplateOutlet="footerContent"></ng-container>
        </div>
      </div>
    }
  }
}
